import { observer } from "mobx-react";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ROUTE_TYPE, LABEL } from "../../HelperSrc";
import { lang } from "../../lang";

@observer
class BreadcrumbBase extends React.Component<RouteComponentProps> {
    public render() {
        return (
            <div className="view_breadcrumb">
                {(() => {
                    const html: JSX.Element[] = [];

                    const separator = " > ";
                    let pathname = window.location.pathname.replace(`/${LABEL}`, "");
                    let result = pathname.replace("/", separator);

                    while (result !== pathname) {
                        pathname = pathname.replace("/", separator);
                        result = result.replace("/", separator);
                    }

                    html.push(
                        <div key={"breadcrumb"} className="text">
                            <p
                                data-at_id="breadcrumb_home"
                                onClick={() => {
                                    this.props.history.push(ROUTE_TYPE.CLIENTS);
                                }}
                            >
                                <span className="link">{lang.home}</span>
                            </p>
                            <p>
                                <span>{pathname}</span>
                            </p>
                        </div>
                    );

                    return html;
                })()}
            </div>
        );
    }
}

const Breadcrumb = withRouter(BreadcrumbBase);

export { Breadcrumb };
